/**
 * Firebase web config, PUBLIC by design. These values ship in client JS on every
 * Firebase web app; security is enforced by FCM / Firebase rules, not by hiding them.
 * Safe to commit. Env vars override for non-prod projects.
 *
 * ⚠️ Keep these in sync with `public/firebase-messaging-sw.js`, which is a static
 * service worker file and cannot read Vite env vars (so it hardcodes the same config).
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyAbhnT0wLm7XA2haoVO0H3AZsbya6ftvNs",
  // authDomain is what the Google/Apple sheet shows as "to continue to <domain>". Flipped to
  // "insnip.com" (2026-07-21) now that the /__/ reverse-proxy (web/functions/__/[[path]].js) is
  // live + verified on insnip.com, insnip.com is an Authorized Domain, and the insnip.com
  // return/redirect URL is registered with both Apple and Google. Set VITE_FIREBASE_AUTH_DOMAIN
  // to override (e.g. back to insnip-prod.firebaseapp.com) without a code change.
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "insnip.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "insnip-prod",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "insnip-prod.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "591169963161",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "1:591169963161:web:4a6e3e1b3f2fbcc1b6e408",
};

/** Web Push (VAPID) public key from the Firebase console → Cloud Messaging. */
export const vapidKey =
  import.meta.env.VITE_FIREBASE_VAPID_KEY ??
  "BGi-7VCBa94flyBwxSU29leHAY-522t_WcdZwsepPj4z1ayt3Q1zbk3hJdbSZJHUS1Rn8lXt6V62wMC0NjMEheI";
